import { _ as F, a as b } from "./index-DpjUVRH2.mjs";
import * as o from "react";
import { useRef as C, useState as B, useCallback as T, useMemo as S, useContext as V, cloneElement as j, Children as q, isValidElement as D } from "react";
import { u as G, a as w, P as H, S as J, i as N } from "./motion-B7Equlyg.mjs";
function Q() {
  var e = C(!1), i = F(B(0), 2), n = i[0], r = i[1];
  return G(function() {
    return e.current = !0;
  }), T(function() {
    !e.current && r(n + 1);
  }, [n]);
}
var z = 0;
function W() {
  var e = z;
  return z++, e;
}
var R = function(e) {
  var i = e.children, n = e.initial, r = e.isPresent, a = e.onExitComplete, x = e.custom, y = e.presenceAffectsLayout, u = w(X), v = w(W), h = S(
    function() {
      return {
        id: v,
        initial: n,
        isPresent: r,
        custom: x,
        onExitComplete: function(s) {
          u.set(s, !0);
          var l = !0;
          u.forEach(function(c) {
            c || (l = !1);
          }), l && (a == null || a());
        },
        register: function(s) {
          return u.set(s, !1), function() {
            return u.delete(s);
          };
        }
      };
    },
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    y ? void 0 : [r]
  );
  return S(function() {
    u.forEach(function(s, l) {
      return u.set(l, !1);
    });
  }, [r]), o.useEffect(function() {
    !r && !u.size && (a == null || a());
  }, [r]), o.createElement(H.Provider, { value: h }, i);
};
function X() {
  return /* @__PURE__ */ new Map();
}
function m(e) {
  return e.key || "";
}
function Y(e, i) {
  e.forEach(function(n) {
    var r = m(n);
    i.set(r, n);
  });
}
function Z(e) {
  var i = [];
  return q.forEach(e, function(n) {
    D(n) && i.push(n);
  }), i;
}
var te = function(e) {
  var i = e.children, n = e.custom, r = e.initial, a = r === void 0 ? !0 : r, x = e.onExitComplete, y = e.exitBeforeEnter, u = e.presenceAffectsLayout, v = u === void 0 ? !0 : u, h = Q(), s = V(J);
  N(s) && (h = s.forceUpdate);
  var l = C(!0), c = Z(i), p = C(c), P = C(/* @__PURE__ */ new Map()).current, f = C(/* @__PURE__ */ new Set()).current;
  if (Y(c, P), l.current)
    return l.current = !1, o.createElement(o.Fragment, null, c.map(function(t) {
      return o.createElement(R, { key: m(t), isPresent: !0, initial: a ? void 0 : !1, presenceAffectsLayout: v }, t);
    }));
  for (var d = b([], F(c)), g = p.current.map(m), I = c.map(m), M = g.length, A = 0; A < M; A++) {
    var L = g[A];
    I.indexOf(L) === -1 ? f.add(L) : f.delete(L);
  }
  return y && f.size && (d = []), f.forEach(function(t) {
    if (I.indexOf(t) === -1) {
      var E = P.get(t);
      if (E) {
        var k = g.indexOf(t), K = function() {
          P.delete(t), f.delete(t);
          var O = p.current.findIndex(function(U) {
            return U.key === t;
          });
          p.current.splice(O, 1), f.size || (p.current = c, h(), x && x());
        };
        d.splice(k, 0, o.createElement(R, { key: m(E), isPresent: !1, onExitComplete: K, custom: n, presenceAffectsLayout: v }, E));
      }
    }
  }), d = d.map(function(t) {
    var E = t.key;
    return f.has(E) ? t : o.createElement(R, { key: m(t), isPresent: !0, presenceAffectsLayout: v }, t);
  }), p.current = d, o.createElement(o.Fragment, null, f.size ? d : d.map(function(t) {
    return j(t);
  }));
};
export {
  te as A
};
//# sourceMappingURL=index-C-vGVq3z.mjs.map
